<script setup lang="ts">
import { defineProps, ref } from 'vue'
import BaseInputText from './BaseInputText.vue'
import BaseButtonMuted from './BaseButtonMuted.vue'
import { ClipboardCheckIcon } from '@heroicons/vue/outline'
import { notify } from '../../utilities/useNotifications'
import { i18n } from '../../localization'

const props = defineProps<{
    value: string
}>()
const input = ref(props.value)

function copyToClipboard() {
    // Note: This feature is available only in secure contexts (HTTPS)
    navigator.clipboard.writeText(input.value).then(() => {
        notify('Success', i18n.global.t('success'), i18n.global.t('copied_to_clipboard'))
    })
}
</script>

<template>
    <BaseInputText
        v-model="input"
        v-bind="$attrs"
        :name="'referralUrl_' + value"
        readonly
        class="h-14 !text-base"
        @click.self="$event.target.select()">
        <template #add-on>
            <BaseButtonMuted
                v-tooltip="$t('copy_to_clipboard')"
                class="!shadow-none focus:ring-offset-0"
                :icon="ClipboardCheckIcon"
                @click="copyToClipboard"
                >{{ $t('copy') }}</BaseButtonMuted
            >
        </template>
    </BaseInputText>
</template>
